// Brand palette. Single source of truth for JS code.
//
// CSS uses --rc-* variables in :root (see src/index.css). React inline
// styles can't reference CSS vars directly when computing arbitrary
// values, so we mirror the same palette here. Both files MUST agree.
// If you change a brand colour, update both.
//
// 2026-09 rebrand: the violet/teal identity is retired. The brand now
// lives in the Makler-Premium world — deep pine green, brass, warm
// ivory (see the landing's `.makler` theme in index.css).
//
// Keep these short, named, and grouped. Every consumer imports by
// name so a rename here surfaces every callsite at compile time.

export const RC_PINE = '#1f4d3a';   // primary brand green (Tannengrün)
export const RC_PINE_DARK = '#163a2c';
export const RC_BRASS = '#c7a869';  // accent (play triangle, wordmark dot)
export const RC_IVORY = '#f7f3ea';  // light brand ground
export const RC_INK = '#23211a';    // wordmark text on light surfaces
export const RC_TEXT = '#f8fafc';   // wordmark text on dark surfaces
